import { useQuery } from 'react-query';

import { OwnerService } from '@/api';

export const GetOrderDetail = 'getOrderDetailsQuery';

export const useGetOrderDetailsQuery = ({ orderId }: { orderId?: string }) => {
  const { data: orderDetail } = useQuery(
    [GetOrderDetail, { orderId }],
    async () => {
      if (!orderId) {
        return undefined;
      }

      const response = await OwnerService.getOrderDetailsQuery({
        orderId,
      });

      if (response.failure) {
        return undefined;
      }

      return response.value;
    },
    {
      staleTime: Infinity,
    },
  );

  return {
    orderDetail,
  };
};
